export default "__VITE_ASSET__CV6QuE97__"